if (!customElements.get('mwt-slider-component')) {
  customElements.define('mwt-slider-component', class MWTSilderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.mwt-slider');
    }

    connectedCallback() {
      const autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
      const autoPlaySpeed = parseInt(this.getAttribute('data-speed'), 10) * 1000;
      this.autoPlayEnabled = autoplayEnabled && autoPlaySpeed > 0;

      if (!this.slider) {
        return;
      }

      this.slider.style.display = 'block';
      this.flickity = new Flickity(this.slider, {
        autoPlay: autoplayEnabled ? autoPlaySpeed : false,
        cellAlign: 'left',
        percentPosition: true,
        fullscreen: true,
        contain: true,
        resize: true,
        draggable: true,
        prevNextButtons: false,
        cellSelector: '.mwt-slider-slide',
        initialIndex: 0,
        pageDots: false,
        wrapAround: false,
        accessibility: false,
        on: {
          ready: () => {
            this.preloadSlide(1);
          },
        },
      });

      this.flickity.on('change', (index) => {
        this.preloadSlide(index + 1);

        const event = new CustomEvent('mwt-slider:slide-change', {
          detail: {
            id: this.getAttribute('id'),
            index,
            total: this.flickity.slides.length,
          },
        });
        document.dispatchEvent(event);
      });
    }

    preloadSlide(index) {
      const slide = this.querySelectorAll('.mwt-slider-slide')[index];

      if (slide) {
        const media = slide.querySelector('.mwt-slider-media');
        if (media) media.style.display = 'block';

        const images = slide.querySelectorAll('img');
        [...images].forEach(image => {
          image.loading = '';
        });
      }
    }
  });
}

if (!customElements.get('mwt-slider-navigation')) {
  customElements.define('mwt-slider-navigation', class MWTSliderNavigation extends HTMLElement {
    constructor() {
      super();
      this.slider = this.closest('mwt-slider-component');
    }

    connectedCallback() {
      this.flickity = this.slider.flickity;

      const buttons = this.querySelectorAll('.js-page');
      this.progress = this.querySelector('.mwt-slider-progress');
      this.progressCurrent = this.querySelector('.js-progress-current');
      this.progressTotal = this.querySelector('.js-progress-total');
      this.progressBar = this.querySelector('.js-progress-bar');
      if (this.flickity) {
        this.flickity.on('select', () => {
          buttons.forEach(button => {
            button.classList.remove('is-active');
          });
          buttons[this.flickity.selectedIndex]?.classList.add('is-active');

          this.updateProgress();
        });

        buttons.forEach(button => {
          button.addEventListener('click', () => {
            const index = [...buttons].findIndex(x => x === button);
            this.flickity.select(index);
          });
        });
      }

      this.buttonPrev = this.querySelector('.js-prev');
      this.buttonNext = this.querySelector('.js-next');

      this.updateButtonStates();
      this.updateProgress();

      this.flickity.on('change', () => {
        this.updateButtonStates();
      });

      this.buttonPrev?.addEventListener('click', (event) => {
        event.preventDefault();
        if (!this.buttonPrev.classList.contains('disabled')) {
          this.flickity?.previous();
        }
      });

      this.buttonNext?.addEventListener('click', (event) => {
        event.preventDefault();
        if (!this.buttonNext.classList.contains('disabled')) {
          this.flickity?.next();
        }
      });
    }

    updateButtonStates() {
      if (!this.flickity) return;

      const currentIndex = this.flickity.selectedIndex;
      const totalSlides = this.flickity.slides.length;

      // Update previous button
      if (this.buttonPrev) {
        if (currentIndex === 0) {
          this.buttonPrev.classList.add('disabled');
        } else {
          this.buttonPrev.classList.remove('disabled');
        }
      }

      // Update next button
      if (this.buttonNext) {
        if (currentIndex === totalSlides - 1) {
          this.buttonNext.classList.add('disabled');
        } else {
          this.buttonNext.classList.remove('disabled');
        }
      }
    }

    updateProgress() {
      if (!this.flickity || !this.progress) return;
      const current = this.flickity.selectedIndex + 1;
      const total = this.flickity.slides.length;
      if (this.progressCurrent) this.progressCurrent.textContent = current;
      if (this.progressTotal) this.progressTotal.textContent = total;
      if (this.progressBar) {
        const pct = total > 0 ? (current / total) * 100 : 0;
        this.progressBar.style.width = `${pct}%`;
      }
    }
  });
}


